import React, { useRef } from "react";
import PropTypes from "prop-types";

import LogoPreview from "./LogoPreview";
import CoverPreview from "./CoverPreview";

import { StyledButton } from "ui/StyledComponents/StyledButton";

import { Box } from "@mui/material";
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import UploadIcon from '@mui/icons-material/Upload';

const ImageEditor = ({ name, value, file, onChange, onImageRemove }) => {

  const imageSrc = file ? window.URL.createObjectURL(file) : value;
  
  const hiddenFileInput = useRef(null);

  const handleFileUpload = (event) => {
    if (!event.target.files) return;
    const file = event.target.files[0];
    onChange({ target: { name: `${name}_file`, value: file } });
  };

  return (
    <>
      {name === "logo" && (
        <LogoPreview imageSrc={imageSrc} />
      )}

      {name === "cover_image" && (
        <CoverPreview imageSrc={imageSrc} />
      )}

      <Box sx={{ display: "flex", gap: 2 }}>
        <StyledButton
          variant="outlined"
          onClick={(event) => {
            event.preventDefault();
            hiddenFileInput.current.click();
          }}
          startIcon={<UploadIcon />}
        >
          Choose Image
        </StyledButton>
        <input
          type="file"
          accept="image/jpeg, image/png, image/gif, image/bmp, image/webp, image/svg+xml"
          name={name}
          ref={hiddenFileInput}
          onChange={handleFileUpload}
          style={{ display: "none" }}
        />
        <StyledButton
          variant="outlined"
          color="error"
          onClick={onImageRemove}
          disabled={!imageSrc}
          startIcon={<RemoveCircleIcon />}
        >
          Remove Image
        </StyledButton>
      </Box>
    </>
  );
}

ImageEditor.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  file: PropTypes.object,
  onChange: PropTypes.func,
  onImageRemove: PropTypes.func,
};

export default ImageEditor;
